import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const HelpText = () => {
  const { t } = useTranslation();
  return (
    <Box>
      <Stack
        alignItems="center"
        justifyContent="flex-start"
        direction="row"
        sx={{
          bgcolor: 'primaryLight.50',
          p: 2,
          borderRadius: '4px',
          ml: '24px',
        }}
      >
        <Typography color="primaryDark.600">{t('projects.projectRequest.helperText')}</Typography>
      </Stack>
    </Box>
  );
};

export default HelpText;
